export const theme = {
  mainColor1: '#4880FF',
  mainColor2: '#53B5FF',
  mainColor3: '#3BAEDC',
  subColor1: '#FF6853',
  subColor2: '#292E42',
  subColor3: '#DD6868',
  bgColor1: '#F2F4F6',
  errorBgColor: '#FFE4E4',
  errorColor: '#DD6868',
  confirmBgColor: '#F4FFE4',
  confirmColor: '#24BB33',
  inputBorderColor: '#ECECEC',
  inputPlaceholderColor: '#B9B9B9',
  inputColor: '#555555',
  inputDefaultColor: '#777',
  inputDefaultBackgroundColor: '#F3F3F3',
  bsType1: '0px 2px 6px rgba(188, 191, 209, 0.2)',
};
